import styled from 'styled-components';

export const ContainerStyle = styled.div`
  padding: 20px;
`;

export const EmptyMessageStyle = styled.div`
  text-align: center;
  padding: 40px 20px;
  color: #999;
  font-size: 14px;
`;

export const AttributeListStyle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 20px 0;
`;
